export const IS_SELLER = 'isSeller';
export const IS_NOT_SELLER = 'isNotSeller';
